import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight, Scale, Zap } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/shop/ProductCard";

export default function EbikeSpotlight() {
  const [bikes, setBikes] = useState([]);

  useEffect(() => {
    api
      .get("/products", { params: { category: "E-Bikes", limit: 40 } })
      .then((r) => {
        const items = r.data.items || r.data || [];
        const qlife = items.filter((p) => (p.sku || "").startsWith("QLIFE-"));
        setBikes((qlife.length ? qlife : items).slice(0, 6));
      })
      .catch(() => {});
  }, []);

  if (!bikes.length) return null;

  return (
    <section className="bg-gray-100 border-y border-gray-200" data-testid="home-ebike-spotlight">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-14 lg:py-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#0A1C40] text-[#FFC220] text-[10px] font-black tracking-[0.2em] uppercase px-3 py-1.5">
              <Zap className="w-3 h-3" /> New Lineup · Just Landed
            </div>
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter mt-3 text-[#0A1C40]">
              Qlife <span className="text-[#C9971E]">E-Bikes</span> — 24 models, ~5-day delivery.
            </h2>
            <p className="text-gray-600 mt-3 max-w-xl">
              Fat tire, commuter, folding, mountain, dirt &amp; trikes — ships to you brand-new in
              box with a 1-year warranty on battery, motor, controller and frame.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 self-start lg:self-end">
            <Link
              to="/ebikes/compare"
              className="inline-flex items-center gap-2 border-2 border-[#0A1C40] text-[#0A1C40] font-black px-5 py-3 hover:bg-[#0A1C40] hover:text-white transition-colors"
              data-testid="home-ebike-compare-cta"
            >
              <Scale className="w-4 h-4" /> Compare models
            </Link>
            <Link
              to="/shop?category=E-Bikes"
              className="inline-flex items-center gap-2 bg-[#FFC220] text-[#0A1C40] font-black px-5 py-3 hover:bg-[#0A1C40] hover:text-[#FFC220] transition-colors"
              data-testid="home-ebike-shop-cta"
            >
              Shop all e-bikes <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 lg:gap-4">
          {bikes.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
